<template>
<div class="chapter">
<div class="inner_page">
<div class="ipadfp"><a id="page_iii"><img alt="The Many Lives &amp; Secret Sorrows of Josephine B, by Sandra Gulland, Atria" class="imagefp" src="images/title.jpg"/></a></div><a id="page_iii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?3da106e1